'use strict';

var $ = require('jquery');
var ajax = require('../../utils/ajax');
var progress = require('../../utils/progress');
var util = require('../../utils/util');
var uniform = require('../../components/uniform');
var packstation = require('../../components/packstation');
var inputfields = require('../../utils/inputfields');
var showLoading = require('../../utils/showLoading');
var addressAutocomplete = require('../../components/googlePlacesAutocomplete');
var deliveryTime = require('./deliveryTime');
var collectionPoint = require('./collectionPoint');
var formPrepare = require('./formPrepare');
var privacyOverlay = require('../../components/privacy-overlay');
const afterpayFlyin = require('../../components/checkout/afterpayFlyin');
var urlUtil = require('../../utils/url');
const bopisTracking = require('../../components/tracking/bopis');
const addressSearch = require('./addressSearch');

import {debounce} from '../../components/custom-lodash';

var pageLoaded = false;
var shippingMethods;
var narvarEDDEnabledOnCheckout = SitePreferences.NARVAR_EDD_ENABLED_ON_CHECKOUT;
var addressAutocompleteInitMap = {
    jsBillingAddressForm: false,
    jsShippingAddressForm: false
};
const PUDO_MAP = {lapostepudo: 'colissimo', dhlpudopl: 'js-dhl24', bpostpudobe: 'js-bpost'};
const $shippingCollectionPoint = $('.is-collection-point-row input');

inputfields.setBillingShippingUpdateCallback(updateShippingMethodList);

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been
 *              applied
 */
function updateSummary() {
    var $summary = $('.jsSummary');
    // indicate progress
    progress.show($summary);

    // load the updated summary area
    $summary.load(Urls.summaryRefreshURL, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
    });
}

function getShippingMethodURL(url, params) {
    return util.appendParamsToUrl(url, params);
}
/**
 * form tries to find the best fitting, available form
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURLParams(extraParams) {
    let $form;
    let params = {};
    let $addressSelect;
    let addressData;
    let i;
    let $useAsShipping = $('.use-same-address-row input');
    /**
     * TODO: the logic of 'use-same-address-row' button seems to be inverted in code. This button
     * is actually used for flagging when the billing address is different from shipping address.
     * This module - and likely others - are using it to flag billing address being THE SAME as address.
     */
    let formElement = $('form:first');
    let shippingFirst = formElement && formElement.length > 0 ? formElement.hasClass('js-shipping-first') : false;

    if ($useAsShipping && $useAsShipping.length > 0) {
        if (!$useAsShipping.is(':checked') && !shippingFirst) {
            $form = $('.jsBillingAddressForm');
            $addressSelect = $('.jsBillingAddressArea .jsAddressSelect:checked');
        } else {
            $form = $('.jsShippingAddressForm');
            $addressSelect = $('.jsShippingAddressArea .jsAddressSelect:checked');
        }
    } else {
        $form = $('.address');
    }

    if ($addressSelect && $addressSelect.length === 1) {
        addressData = $addressSelect.data('address');
    }
    if (addressData) {
        // already contains parameter "packstation" (true, false or not at all)
        $.each(addressData, function (key, value) {
            if (value) {
                // don't add null or empty values
                params[key] = value;
            }
        });
    } else {
        // dynamically take all inputs from form
        let $inputs = $form.find(':input[type!="hidden"]');
        for (i = 0; i < $inputs.length; i++) {
            let $input = $($inputs[i]);
            let name = $input.attr('name');
            let val = $input.val();
            if (val && name) {
                name = name.substring(name.lastIndexOf('_') + 1, name.length);
                params[name] = val;
            }
        }
        // append current packstation selection
        params.packstation =
            $('.is-packstation-row input:checked') && $('.is-packstation-row input:checked').length >= 1;
        params.isPoBox =
            $('.is-packstation-row input:checked') && $('.shipping-is-po-box-row input:checked').length >= 1;
        params.isCollectionPoint = $shippingCollectionPoint.is(':checked') && $shippingCollectionPoint.length >= 1;
    }
    return $.extend(params, extraParams);
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the
 *              right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(
        Urls.selectShippingMethodsList,
        getShippingMethodURLParams({
            shippingMethodID: shippingMethodID
        })
    );
    ajax.getJson({
        url: url,
        callback: function (data) {
            updateSummary();
            if ((!data || !data.shippingMethodID) && !data.shippingMethodsUnavailable) {
                /*eslint-disable no-alert */
                window.alert("Couldn't select shipping method.");
                /*eslint-enable no-alert */
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();

            deliveryTime.updateDeliveryTime();
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list'),
        url,
        params;
    if (!$shippingMethodList || $shippingMethodList.length === 0) {
        return;
    }

    params = getShippingMethodURLParams();
    $('.step.active').attr('aria-current', 'step');

    var smlUrl = getShippingMethodURL(Urls.shippingMethodsList, params);
    $shippingMethodList.load(smlUrl, function () {
        var coContinueButton = $shippingMethodList
            .closest('.checkout-shipping-method')
            .find('.checkout-continue button');
        $shippingMethodList.fadeIn('fast');

        let $collectionpoints = $('#collectionPoints');
        if ($shippingMethodList.find('.checkout-shipping-method-form').length === 0) {
            coContinueButton.prop('disabled', true);
        } else {
            // rebind the radio buttons onclick function to a handler.
            $shippingMethodList.find('[name$="_shippingMethodID"]:not([disabled])').click(function () {
                var clickedMethod = $(this);
                selectShippingMethod(clickedMethod.val());
                $('.address-without-phone').hide();
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'shipping-method-selected',
                        elementId: this.id
                    });
                }

                if ($collectionpoints.length > 0) {
                    if (clickedMethod.data('collection-point')) {
                        let collectionPointId = this?.id?.toLowerCase() || '';
                        if (collectionPointId && PUDO_MAP[collectionPointId]) {
                            $collectionpoints.empty();
                            $collectionpoints.append(`<span class="${PUDO_MAP[collectionPointId]} hidden"></span>`);
                            collectionPoint.switchToCollectionPoint(true);
                        }
                    } else {
                        $collectionpoints.empty();
                        collectionPoint.switchToCollectionPoint(false);
                    }
                }
            });

            // update the summary
            updateSummary();
            progress.hide();

            let $pudoMethod = $shippingMethodList.find('[name$="_shippingMethodID"]:not([disabled])[id*="PUDO"]')[0];
            if ($shippingCollectionPoint.length > 0 && $shippingCollectionPoint.is(':checked')) {
                $shippingMethodList
                    .find('[name$="_shippingMethodID"]:not([disabled]):not([id*="PUDO"])')
                    .parent()
                    .css('display', 'none');
                $pudoMethod.click();
            } else if ($pudoMethod) {
                $pudoMethod.parentElement.style.display = 'none';
                $pudoMethod.checked = false;
            }

            //if nothing is selected in the shipping methods select the first one
            if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                $shippingMethodList.find('.input-radio:first')[0].click();
            } else if (!pageLoaded) {
                $shippingMethodList.find('.input-radio:checked')[0].click();
                pageLoaded = true;
            }

            deliveryTime.updateDeliveryTime();

            coContinueButton.prop('disabled', false);

            // uniform re-init
            uniform();

            var savedPostalCode = '';

            if (
                $("input[name='dwfrm_singleshipping_shippingAddressName']:checked").length > 0 &&
                typeof $("input[name='dwfrm_singleshipping_shippingAddressName']:checked").attr('data-address') !==
                    'undefined'
            ) {
                var dataAddressObj = JSON.parse(
                    $("input[name='dwfrm_singleshipping_shippingAddressName']:checked").attr('data-address')
                );
                savedPostalCode = dataAddressObj.postal;

                let billingForm = $('.jsBillingAddressArea');
                let useSameAddressRow = $('.use-same-address-row');
                let useSameAddress = $('.use-same-address-row input');

                if (dataAddressObj.packstation) {
                    // Always show the billing form when delivery address is packstation.
                    billingForm.show();
                    useSameAddressRow.hide();
                    useSameAddress.prop('checked', true);
                } else if (billingForm.is(':visible') && useSameAddress.is(':checked')) {
                    // If we switch from packstation to normal.
                    useSameAddressRow.show();
                    useSameAddress.prop('checked', true);
                    useSameAddress.closest('span').addClass('checked');
                }
            }

            var postalCode =
                $('.checkout-shipping-address-form .postal-code').val() !== null &&
                $('.checkout-shipping-address-form .postal-code').val() !== ''
                    ? $('.checkout-shipping-address-form .postal-code').val()
                    : savedPostalCode || '';

            if (narvarEDDEnabledOnCheckout && postalCode !== null && postalCode !== '') {
                $('.shipping-method-estimated-arrival-date').each(function () {
                    $(this).attr('data-narvar-dest-zip', postalCode);
                });

                narvar('getEdd', {});
            }
        }
    });
}

afterpayFlyin.init();

function completeUpdateShippingAddressArea(addressArea, useSameAddress, shippingIsPickupPoint, event) {
    if (typeof addressArea !== 'undefined' && addressArea) {
        if (useSameAddress.is(':checked') || shippingIsPickupPoint) {
            if (shippingIsPickupPoint) {
                addressArea.show();
            } else {
                addressArea.slideDown();
            }

            // BSDDEV-2192: Google Address Autocomplete
            // init only if "billing" is clicked and wasn't initialised before.
            // see ..js/components/googlePlacesAutocomplete.js for more details.
            if (addressAutocomplete.enabled && !addressAutocompleteInitMap.jsBillingAddressForm) {
                addressAutocomplete.initAutocompleteForArea(addressArea);
                addressAutocompleteInitMap.jsBillingAddressForm = true;
            }
        } else {
            // only billing form
            addressArea.slideUp();
        }
    }

    // adjust form for packstation if needed
    packstation.updateShippingForPackstation(event);

    updateShippingMethodList();
}

// triggered for clicks on use-same-address and is-packstation
function updateShippingAddressArea(event) {
    var shippingArea = $('.jsShippingAddressArea'),
        billingArea = $('.jsBillingAddressArea'),
        addressSelection = shippingArea.find('.jsAddressSelection'),
        newShippingAddress = shippingArea.find('#newShippingAddress'),
        selectedAddress = addressSelection.find('.jsAddressSelect:checked'),
        useSameAddress = $('.use-same-address-row input'),
        useSameAddressRow = $('.use-same-address-row'),
        isPackstation = $('.is-packstation-row input'),
        createNewCustomer = $('.new-customer-row input'),
        passwordFields = $('.password-fields'),
        passwordInputs = $('.password-fields input'),
        isPackstationEvent = event && $(event.target).closest('.is-packstation-row').length > 0,
        shippingIsPoBox = $('.shipping-is-po-box-row input'),
        addressPlaceholderUpdate = $('[name="' + shippingIsPoBox.data('placeholder-update') + '"]'),
        shippingIsPoBoxEvent = event && $(event.target).closest('.shipping-is-po-box-row input').length > 0,
        shippingIsPickupPoint = $('#radio-shipping-pickup-point').is(':checked'),
        isShippingEvent = event && $(event.target).closest('.use-same-address-row').length > 0,
        reloadAddressSelection = isPackstationEvent || shippingIsPoBoxEvent,
        addressArea;

    passwordInputs.prop('value', null);

    if (createNewCustomer && createNewCustomer.is(':checked')) {
        passwordFields.removeClass('no-password');
    } else {
        passwordFields.addClass('no-password');
    }

    if (passwordFields.hasClass('no-password')) {
        passwordFields.slideUp();
        passwordInputs.removeClass('required');
        passwordInputs.prop('type', 'text');
        passwordInputs.prop('value', null);
        passwordInputs.prop('mandatory', 'false');
    } else {
        passwordFields.slideDown();
        passwordInputs.addClass('required');
        passwordInputs.prop('type', 'password');
        passwordInputs.prop('mandatory', 'true');
    }

    if (
        (isPackstationEvent && isPackstation.is(':checked')) ||
        (shippingIsPoBoxEvent && shippingIsPoBox.is(':checked'))
    ) {
        // packstation has been activated
        useSameAddress.prop('checked', true);
        useSameAddressRow.hide();

        if (addressPlaceholderUpdate.length) {
            addressPlaceholderUpdate.data('placeholder-backup', addressPlaceholderUpdate.attr('placeholder'));
            addressPlaceholderUpdate.attr('placeholder', shippingIsPoBox.data('placeholder-po-name'));
            addressPlaceholderUpdate.next().text(shippingIsPoBox.data('placeholder-po-name'));
        }
    } else {
        if (isPackstationEvent || shippingIsPoBoxEvent) {
            useSameAddress.prop('checked', false);
            useSameAddressRow.show();
        }
        if (addressPlaceholderUpdate.length && addressPlaceholderUpdate.data('placeholder-backup')) {
            addressPlaceholderUpdate.attr('placeholder', addressPlaceholderUpdate.data('placeholder-backup'));
            addressPlaceholderUpdate.next().text(addressPlaceholderUpdate.data('placeholder-backup'));
        }
    }
    if (isShippingEvent && !useSameAddress.is(':checked')) {
        // use as shipping has been deactivated
        isPackstation.prop('checked', false);
        shippingIsPoBox.prop('checked', false);
        reloadAddressSelection = true;
    }
    // uniform re-init (of checkboxes)
    $.uniform.update();

    var $fieldset = $(this).closest('fieldset');
    if ($fieldset.hasClass('jsShippingAddressArea')) {
        addressArea = billingArea;
        $fieldset.toggleClass('pickup-point-shipping', shippingIsPickupPoint);
    } else if ($fieldset.hasClass('jsBillingAddressArea')) {
        addressArea = shippingArea;
    }

    if (reloadAddressSelection && addressSelection.length > 0) {
        function reInitAutocomplete() {
            if (isPackstationEvent) {
                $('#newShippingAddress').click();
            }

            // uniform re-init
            uniform();
            // show address form if found address list is empty
            if (shippingArea.is(':visible')) {
                if (
                    shippingArea.find('.jsAddressSelect').length <= 0 ||
                    shippingArea.find('#newShippingAddress').is(':checked')
                ) {
                    shippingArea.find('.jsShippingAddressForm').slideDown();
                    // re-init after ajax reload
                    if (addressAutocomplete.enabled) {
                        addressAutocomplete.initAutocompleteForArea(shippingArea);
                    }
                }
            }
            if (billingArea.is(':visible')) {
                if (
                    billingArea.find('.jsAddressSelect').length <= 0 ||
                    billingArea.find('#newShippingAddress').is(':checked')
                ) {
                    billingArea.find('.jsBillingAddressForm').slideDown();
                    // re-init after ajax reload
                    if (addressAutocomplete.enabled) {
                        addressAutocomplete.initAutocompleteForArea(billingArea);
                    }
                }
            }

            completeUpdateShippingAddressArea(addressArea, useSameAddress, shippingIsPickupPoint, event);
        }

        const getAddressUrl = util.appendParamsToUrl(Urls.getAddressSelection, {
            poBoxes: shippingIsPoBox.is(':checked'),
            currentAddress: selectedAddress.length > 0 ? encodeURIComponent(selectedAddress.val()) : '',
            newShippingAddress: newShippingAddress && newShippingAddress.is(':checked')
        });

        addressSelection.load(getAddressUrl, reInitAutocomplete);
    } else {
        completeUpdateShippingAddressArea(addressArea, useSameAddress, shippingIsPickupPoint, event);
    }
}

/**
 * Handles the logic for overtaking or editing an address.
 * This function is triggered by a click, space, or enter key event.
 *
 * @param {Event} e - The event object.
 */
function handleAddressOvertake(e) {
    if (util.isClickOrSpaceOrEnter(e)) {
        if (SitePreferences.DIMENSIONAL_DROPDOWN_ENABLED) {
            $('div.address-selection-group').each(function () {
                $(this).find('input[type="text"]').removeAttr('disabled');
            });
        }
        var $target = $(e.target),
            $parent = $target.parents('.jsShippingAddressArea,.jsBillingAddressArea'),
            $newAddress = $parent.find('.jsAddressSelect').last(),
            $input = $target.prevAll('div.radio').find('.jsAddressSelect'),
            addressData = $input.data('address');

        // prefill all form with address data
        $.each(addressData, function (key, value) {
            var $el;
            value = value || '';

            if (key == 'state') {
                key = 'states_state';
            }

            if ($('html').attr('lang') === 'ja' && key === 'salutation') {
                key = 'gender';
                value = value === 'Mr' ? 1 : 2;
                $('#dwfrm_singleshipping_shippingAddress_addressFields_gender_' + value).trigger('click');
            } else if (key === 'salutation' && value && $('.salutation-MEA')) {
                $('.salutation-MEA input[value=' + value + ']').trigger('click');
            }

            if (key === 'city' && value) {
                //Area-billing
                setCityAndArea(value, addressData.cityArea, $target);
            }

            $el = $parent.find('[name$="_addressFields_' + key + '"]:not("' + packstation.pscn + '")');

            if ($el.length > 0) {
                $el.val(value).trigger('blur'); // trigger placeholder update, see inputfields.js
            }
        });
        // select the address being edited
        $newAddress.prop('checked', true);
        $.uniform.update();

        // trigger show form if necessary
        $newAddress.trigger('change', {
            useDifferentBillingAddress: true
        });

        // update shipping methods
        updateShippingMethodList();

        // init the input fields
        inputfields.updateSelectBoxes();
    }
}

/**
 * Handles the change event for the address selection radio.
 *
 * @param {Event} e - The event object.
 * @param {Object} [data] - Additional data passed to the event handler.
 * @param {boolean} [data.useDifferentBillingAddress] - Indicates whether a different billing address is used.
 */
function handleAddressSelectChange(e, data) {
    var $target = $(e.target),
        value = $target.attr('value'),
        showForm =
            $target.parents('.jsShippingAddressArea').length > 0 ? 'jsShippingAddressForm' : 'jsBillingAddressForm',
        form = $('.' + showForm),
        id = e.target.id,
        $addressList = $target.closest('.address-list');
    const useSameAddress = $('.use-same-address-row input');
    const billingForm = $('.jsBillingAddressArea');

    if (value) {
        let savedAddress = $(e.target).data('address');
        if ($('#collectionPoints').children().length > 0 && !savedAddress.phone) {
            $('.jsBillingAddressArea').find('#newShippingAddress').trigger('click');
            collectionPoint.updateFormFromSavedAddress(savedAddress);
            util.scrollBrowser($(e.target).offset().top, true);
        } else if ($('#collectionPoints').children().length > 0 && savedAddress.phone) {
            collectionPoint.updateFormFromSavedAddress(savedAddress);
            $('.address-without-phone').hide();
            if (form.is(':visible')) {
                form.slideUp();
            }
        } else {
            resetAddressForm(e);
            if (form.is(':visible')) {
                form.slideUp();
            }
        }
    } else if (!value) {
        if (!form.is(':visible')) {
            form.slideDown();
        }

        // BSDDEV-2192: Google Address Autocomplete
        // init only if "new address" is clicked and wasn't initialised before.
        // see ..js/components/googlePlacesAutocomplete.js for more details.
        if (addressAutocomplete.enabled && !addressAutocompleteInitMap[showForm]) {
            addressAutocomplete.initAutocompleteForArea(form);
            addressAutocompleteInitMap[showForm] = true;
        }
    }

    $addressList.find('.form-row-radio').find('label').attr('aria-selected', 'false');
    $('label[for="' + id + '"]').attr('aria-selected', 'true');

    const newAddress = 'newShippingAddress';

    // If the user wants new address he should see only the shipping form without billing form opened.
    if (
        id === newAddress &&
        $('#collectionPoints').find('.colissimo, .js-dhl24, .js-bpost').length === 0 &&
        showForm != 'jsBillingAddressForm' &&
        data &&
        !data.useDifferentBillingAddress
    ) {
        const useSameAddressRow = $('.use-same-address-row');

        useSameAddressRow.show();
        useSameAddress.prop('checked', false);
        useSameAddress.closest('span').removeClass('checked');
        billingForm.hide();
    }

    updateShippingMethodList();
}

exports.init = function () {
    const isEnableKakaoAddressSearch = $('.jsShippingAddressForm')
        .find('.address-container')
        .data('enable-kakao-address-search');
    if (isEnableKakaoAddressSearch) {
        addressSearch.init(updateShippingMethodList);
    }

    $('body').on('click', '.show-privacy-overlay', function () {
        $('body').addClass('ui-dialog-position-fixed');
        privacyOverlay.initPrivacyOverlay().open();
    });
    const formToSubmit = document.getElementById('dwfrm_singleshipping_shippingAddress');
    const button = document.getElementById('dwfrm_singleshipping_save');

    showLoading.showLoading(formToSubmit, button);

    if ($('.order-data-validation-error').length > 0 && formToSubmit !== null) {
        $(formToSubmit).validate().form();
    }

    formPrepare.init({
        continueSelector: '[name$="shippingAddress_save"]',
        formSelector: '[id$="singleshipping_shippingAddress"],[id$="billing_billingAddress"]',
        submitButtonSelector: '#dwfrm_singleshipping_save',
        skipInitialValid: true
    });
    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);

    // listen to all address form input fields. For all other inputs event is triggered manually
    $('.address').on('change', '.jsBillingAddressForm :input, .jsShippingAddressForm :input', updateShippingMethodList);
    if ($('.address-without-phone').length > 0) {
        $('.address-without-phone').hide();
    }
    giftMessageBox();
    packstation.updateShippingForPackstation();
    packstation.initResize();
    updateShippingMethodList();
    // updateSubmitAction();
    $('.pt_checkout')
        .on(
            'change',
            '.use-same-address-row input, .is-packstation-row input, .shipping-is-po-box-row input, .new-customer-row input, input[name=shipping-type]',
            updateShippingAddressArea
        )
        .on('click', 'input[type=radio][id="newShippingAddress"]', resetAddressForm)
        .on('change', '.jsAddressSelect', handleAddressSelectChange)
        .on('click keypress', '.jsAddressOvertake', handleAddressOvertake)
        .on('click', '.jsAddressShowAll', function (e) {
            var $target = $(e.target);
            $target.hide();
            $target.next().slideDown();
        })
        .on('change', 'input[name=shipping-type]', function (e) {
            $('.shipping-type-select').removeClass('active');
            var $target = $(e.target);
            $target.closest('.shipping-type-select').addClass('active');
        });

    $('input[name=shipping-type]').prop('disabled', false);

    $('.step.active').attr('aria-current', 'step');

    $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').on(
        'change',
        debounce(function () {
            updateShippingMethodList();
            //updateSummary();
        }, 10)
    );

    $('#dwfrm_singleshipping_save').click(function (e) {
        if ($('.checkout-collection-point-form').is(':visible')) {
            collectionPointNotSelected(e);
            return;
        }
        if ($('.selected-collection-point-form').is(':visible')) {
            $('#dwfrm_singleshipping_shippingAddress_addressFields_salutation').val(
                $('#dwfrm_singleshipping_billingAddress_addressFields_salutation').val()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_salutation').trigger('click');
            $('#dwfrm_singleshipping_shippingAddress_addressFields_firstName').val(
                $('#dwfrm_singleshipping_billingAddress_addressFields_firstName').val()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_lastName').val(
                $('#dwfrm_singleshipping_billingAddress_addressFields_lastName').val()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_phone').val(
                $('#dwfrm_singleshipping_billingAddress_addressFields_phone').val()
            );
            $('#dwfrm_singleshipping_shippingAddress_addressFields_areaCode').val(
                $('#dwfrm_singleshipping_billingAddress_addressFields_areaCode').val()
            );

            let $address1 = $('#dwfrm_singleshipping_shippingAddress_addressFields_address1');
            let $streetNo = $('#dwfrm_singleshipping_shippingAddress_addressFields_streetNo');
            let $city = $('#dwfrm_singleshipping_shippingAddress_addressFields_city');
            let splitAddress = $address1.val().split(' ');
            if (isNaN(splitAddress[0])) {
                if (splitAddress[0].length <= 5 && !isNaN(parseInt(splitAddress[0]))) {
                    $streetNo.val(splitAddress.shift());
                    $address1.val(splitAddress.join(' '));
                }
                if (!$streetNo.val().trim()) {
                    $streetNo.val('-');
                }
            } else {
                $streetNo.val(splitAddress.shift());
                $address1.val(splitAddress.join(' '));
            }
            let city = $city.val().trim();
            city = city.replace(/,$/, '');
            $city.val(city);
            $('.address-without-phone').hide();
        }
        var selectedMethodNarvar = $('.shipping-method-list :radio:checked');
        var selectedMethodNarvarGroup = selectedMethodNarvar.closest('.form-row-radio');
        var narvarArrivalDate = selectedMethodNarvarGroup.find('.shipping-method-estimated-arrival-date');
        if (narvarArrivalDate.length == 1) {
            var narvarDate = narvarArrivalDate.html();
            setCookie('narvarDate', narvarDate);
        }
    });

    $('#dwfrm_singleshipping_save').on('click', function (e) {
        if ($('.jsAddressSelection .jsActionSelect').length !== 0) {
            var $selectedAddresses = $('.jsAddressSelection .jsActionSelect').find('.checked:visible');

            for (var i = 0; i < $selectedAddresses.length; i++) {
                var $address = $selectedAddresses.eq(i);

                var $parent = $address.parents('.jsShippingAddressArea,.jsBillingAddressArea'),
                    $form = $parent.parents('form'),
                    $newAddress = $parent.find('.jsAddressSelect').last(),
                    $input = $address.find('.jsAddressSelect'),
                    addressData = $input.data('address');

                if (addressData && (addressData.firstName == null || addressData.lastName == null)) {
                    e.preventDefault();

                    // prefill all form with address data
                    $.each(addressData, function (key, value) {
                        var $el;
                        value = value || '';
                        if (key == 'state') {
                            key = 'states_state';
                        }

                        if ($('html').attr('lang') === 'ja' && key === 'salutation') {
                            key = 'gender';
                            value = value === 'Mr' ? 1 : 2;
                        } else if (key === 'salutation') {
                            if (value == null || value == '') {
                                var $elSalutation = $parent.find(
                                    '[name$="_addressFields_' + key + '"]:not("' + packstation.pscn + '")'
                                );
                                if ($elSalutation.length > 0) {
                                    $elSalutation.parent().removeClass('active');
                                    $elSalutation.each(function () {
                                        var $button = $(this);
                                        $button.prop('checked', false);
                                    });
                                }
                            }
                            return;
                        }

                        $el = $parent.find('[name$="_addressFields_' + key + '"]:not("' + packstation.pscn + '")');
                        if ($el.length > 0) {
                            $el.val(value).trigger('blur'); // trigger placeholder update
                        }
                    });

                    // switch to new address
                    $newAddress.prop('checked', true);
                    $.uniform.update();
                    $newAddress.trigger('change');
                    updateShippingMethodList();
                    inputfields.updateSelectBoxes();
                    $form.validate().form();
                    util.scrollBrowser($parent.offset().top, true);
                }
            }
        }
    });

    let $usePickupAddress = $('[name="dwfrm_singleshipping_usePickupAddress"]');

    if ($usePickupAddress.is(':checked')) {
        $('.use-pickup-contact').show();
    }

    // Removes validation errors when the pickupcontact form is not visible
    if ($('[name="dwfrm_singleshipping_usePickupAddress"]:checked').val() !== 'true') {
        const $inputs = $('.jsPickupContactForm :input');

        $inputs.each(function () {
            let $parent = $(this).parent();
            let $error = $parent.find('.error-msg').find('.error-msg-inner');

            $error.hide();
            $parent.removeClass('validation-error');
        });
    }

    $usePickupAddress.on('click', function (e) {
        $('.use-pickup-contact').toggle();
        bopisTracking.recordDifferentContactTick($usePickupAddress.is(':checked'));
    });

    $('#dwfrm_singleshipping_subscribeToSMS').on('change', function (e) {
        let isSubscribeToSMS = e.currentTarget.checked;

        if (isSubscribeToSMS) {
            $('.wrapper-subscribe-sms').show();
        } else {
            $('.wrapper-subscribe-sms').hide();
        }
    });

    $('#dwfrm_singleshipping_subscribeToSMS').trigger('change');

    $shippingCollectionPoint.on('change', function () {
        updateShippingMethodList();
    });
};

/**
 * @function
 * @param {event} e - triggers when new address radio is selected/deselected
 * @description resets (if already populated) the shipping/billing address form on checkout page
 * and the user sees and empty form to add the new address
 */
function resetAddressForm(e) {
    let $newAddress = $(e.currentTarget);
    let $fieldset = $newAddress.parents('fieldset');
    // Reset the form on fieldset level ($fieldset can be .jsShippingAddressArea or .jsBillingAddressArea)
    $fieldset
        .find(':input[type="text"], input[type="number"], input[type="tel"]')
        .not('button, submit, reset, hidden, .input-preselect')
        .val('');
    // Reset dropdown selection for e.g. City
    // reseting .gpac-field-country is breaking google autosuggest
    $fieldset.find('select').not('.gpac-field-country, .input-preselect, .jsAreaCode').prop('selectedIndex', 0);
    // Reset radio selection for e.g. salutation(MEA)
    $fieldset.find('input[type="radio"]').each(function () {
        let $radio = $(this);
        $radio.prop('selected', false);
        $radio.closest('label').removeClass('active');
    });

    $.uniform.update();
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function collectionPointNotSelected(e) {
    e.preventDefault();
    const error = Resources.INVALID_COLLECTION_POINT;
    const $input = $('#dwfrm_singleshipping_collectionPoint_collectionAddress');
    const $error = $input.parent().find('.error-msg').find('.error-msg-inner');
    const $notSelected = $('.collection-point-notselected-error');
    const $collectionPointForm = $('.jsCollectionPointArea');
    if ($input.val().match(/^.+,.+$/)) {
        $error.hide();
        $input.parent().removeClass('validation-error');
        $notSelected.show();
    } else {
        $notSelected.hide();
        $error.html(error);
        $error.show();
        $input.parent().addClass('validation-error');
    }
    util.scrollBrowser($collectionPointForm.offset().top, true);
    progress.hide();
}

/***
 * @description This function takes a city, cityArea and fills the value of the fields on change the shipping and billing address.
 * @param {String} city
 * @param {String} cityArea
 * @param {Object} target
 */

function setCityAndArea(city, cityArea, target) {
    if (city) {
        const isShippingAddress =
            target.parents('.jsShippingAddressArea').length > 0 ? 'jsShippingAddressForm' : 'jsBillingAddressForm';
        let cityAreaField = '';
        let selectedCityId = city;
        if (isShippingAddress != 'jsBillingAddressForm') {
            $('#dropdown-city-shipping').val(city);
            cityAreaField = $('#dropdown-area-shipping');
            selectedCityId = $('#dropdown-city-shipping option:selected').attr('data-city');
        } else {
            $('#dropdown-city-billing').val(city);
            cityAreaField = $('#dropdown-area-billing');
            selectedCityId = $('#dropdown-city-billing option:selected').attr('data-city');
        }

        var params = {
            format: 'ajax',
            city: selectedCityId
        };
        var url = urlUtil.appendParamsToUrl(Urls.getAreasByCity, params);
        $.ajax({
            url: url,
            dataType: 'html',
            success: function (data) {
                cityAreaField.empty().append(data);
            },
            complete: function (data) {
                if (cityArea) {
                    cityAreaField.val(cityArea);
                    cityAreaField.trigger('change');
                }
            }
        });
    }
}

exports.updateShippingMethodList = updateShippingMethodList;
